import { render, staticRenderFns } from "./Contactenos.vue?vue&type=template&id=74a0aef3&"
import script from "./Contactenos.vue?vue&type=script&lang=js&"
export * from "./Contactenos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports